import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import InterviewPage from "./pages/InterviewPage";
import AssessmentPage from "./pages/AssessmentPage";
import CatalogPage from "./pages/CatalogPage";
import LeadsPage from "./pages/LeadsPage";
import FreeAssessmentPage from "./pages/FreeAssessmentPage";
import SnapshotsPage from "./pages/SnapshotsPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-ivory flex items-center justify-center text-navy/40">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage mode="login" />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<Private><DashboardPage /></Private>} />
          <Route path="/interviews/:id" element={<Private><InterviewPage /></Private>} />
          <Route path="/interviews/:id/assessment" element={<Private><AssessmentPage /></Private>} />
          <Route path="/catalog" element={<Private><CatalogPage /></Private>} />
          <Route path="/leads" element={<Private><LeadsPage /></Private>} />
          <Route path="/snapshots" element={<Private><SnapshotsPage /></Private>} />
          <Route path="/free-assessment" element={<FreeAssessmentPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/public/:token" element={<InterviewPage publicMode={true} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
